var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"t",rawName:"v-t",value:('demo.badge'),expression:"'demo.badge'"}],staticClass:"demo-badge"})
}
var staticRenderFns = []

export { render, staticRenderFns }